
import { Component, Input } from '@angular/core';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'app-no-data',
    templateUrl: './no-data.component.html',
    styleUrls: ['no-data.component.scss'],
    standalone: false
})
export class NoDataComponent {
  @Input() display: boolean;
}
